import React from "react";
//import FlatButton from "material-ui/FlatButton";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import ImportCSVButton from "./ImportCSVButton";

export const SimActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter,
  refresh
}) => (
  <CardActions style={styles.cardActionStyleSmall} className="detail-actions">
    <ImportCSVButton basePath={basePath} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/sim/defaultValues.js